module.exports = __webpack_public_path__ + "static/media/header-right-image.818c92d8.png";